import { gql } from "lib/apolloClient";
import { studentDetailsFragment } from "ClassRoom/modules/ClassRoomFragments";
import { courseItemFragment } from "./LearningCourseFragments";
import { projectGroupFragments } from "modules/CommonFragments";

export const getLearningCourseDetailsQuery = gql`
  query getLearningCourseDetails(
    $learningCourseId: ID!
    $userArchivedFilters: UserArchivedFilters
    $classFilters: LearningCourseClassFilter
    $termFilters: TermFilters
    $gradeFilters: LearningCourseGradeFilters
  ) {
    node(id: $learningCourseId, type: LEARNING_COURSE) {
      id
      ... on LearningCourse {
        id
        isArchived
        type
        title
        bluePrintCourse {
          id
          title
        }
        lockingInfo {
          isLocked
          pageTypes
        }
        updatedAt
        academicCourse {
          id
        }
        curriculumProgram {
          id
        }
        academicYears {
          id
          startDate
          endDate
        }
        startDate
        endDate
        associatedLevels {
          id
          label
          abbreviation
          isArchived
        }
        primaryGrade(filters: $gradeFilters) {
          id
          name
        }
        classes(filters: $classFilters) {
          id
          title
          isActive
          isArchived
          projectGroups(
            filters: {
              projectGroupSubTypes: [INTERNAL_ASSESSMENT, EXTERNAL_ASSESSMENT]
            }
          ) {
            ...basicProjectGroupDetails
          }
          profileImageData {
            icon
            color
            acronym
            url
          }
          primaryGrade {
            id
          }
          students {
            totalCount
            edges {
              node {
                ...studentItem
              }
            }
          }
          subjects {
            id
            type
            name
            metadata
            __typename
          }
        }
        grades(filters: $gradeFilters) {
          id
        }
        subjects {
          id
          name
          isArchived
          type
          recommendedPhase {
            gradeId
            phaseId
          }
          subjectGroup {
            id
            name
            type
          }
          metadata
        }
        aiConversation {
          edges {
            node {
              id
              entityType
              entitySubType
              metadata
            }
          }
        }
        standardsWrapper {
          standardsEdge {
            standardSet {
              id
              title
              subject {
                id
              }
            }
          }
        }
        benchmarksWrapper {
          standardsEdge {
            standardSet {
              id
              title
              subject {
                id
              }
            }
          }
        }
        displayMetadata
        gradingPeriods(filters: $termFilters) {
          totalCount
          edges {
            node {
              id
              label
              lockingStatus
            }
          }
        }
      }
    }
  }
  ${studentDetailsFragment.basicStudentDetails}
  ${projectGroupFragments.basicProjectGroupDetails}
`;

export const getLearningCoursesWithoutPaginationQuery = gql`
  query getLearningCoursesWithoutPaginationQuery(
    $organizationId: ID!
    $filters: LearningCourseFilters
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      ... on Organization {
        id
        learningCourses(filters: $filters) {
          edges {
            node {
              ...courseItem
            }
          }
        }
      }
    }
  }
  ${courseItemFragment}
`;

export const getLearningCourseCurriculumQuery = gql`
  query getLearningCourseCurriculum($learningCourseId: ID!) {
    node(id: $learningCourseId, type: LEARNING_COURSE) {
      ... on LearningCourse {
        id
        curriculumProgram {
          id
        }
      }
    }
  }
`;

export const getLearningCourseGradingPeriodsQuery = gql`
  query getLearningCourseGradingPeriods(
    $learningCourseId: ID!
    $filters: TermFilters
  ) {
    node(id: $learningCourseId, type: LEARNING_COURSE) {
      ... on LearningCourse {
        id
        gradingPeriods(filters: $filters) {
          totalCount
        }
      }
    }
  }
`;

export const learningCourseChangeQuery = gql`
  query getLearningCourseChange($learningCourseId: ID!) {
    node(id: $learningCourseId, type: LEARNING_COURSE) {
      ... on LearningCourse {
        id
        type
        blueprintLastUnreadSync {
          id
          lastSynctAt
          syncComment
        }
      }
    }
  }
`;
